//@flow
import convert from 'convert-units';
import _ from 'lodash';

export type SystemType = 'imperial' | 'metric' | 'bits' | 'bytes';

export type UnitType = {
    abbr: string,
    measure: string,
    system: SystemType,
    singular: string,
    plural: string
};

let unitsBySystemList = { imperial: [], metric: [], bits: [], bytes: [] };
let unitsList = {};
let measures = {};

const formatUnit = unit => {
    unitsBySystemList = {
        ...unitsBySystemList,
        [unit.system]: {
            ...unitsBySystemList[unit.system],
            [unit.measure]: {
                ...(unitsBySystemList[unit.system][unit.measure] || {}),
                [unit.abbr]: unit
            }
        }
    };

    unitsList = {
        ...unitsList,
        [unit.measure]: {
            ...(unitsList[unit.measure] || {}),
            [_.upperFirst(_.camelCase(unit.singular))]: unit
        }
    };
    measures = { ...measures, [unit.measure]: unit.measure };
};

convert().list().forEach(formatUnit);

const UnitSystemsEnum = {
    Metric: 'METRIC_SYSTEM',
    Imperial: 'IMPERIAL_SYSTEM'
};

export type MeasurementSystemType = $Values<typeof UnitSystemsEnum>;

const UnitSystemToConvertSystemMap = {
    METRIC_SYSTEM: 'metric',
    IMPERIAL_SYSTEM: 'imperial'
};

const UnitDimensionsEnum = {
    [measures.length]: 'DISTANCE',
    [measures.mass]: 'WEIGHT',
    [measures.time]: 'TIME', // this is frontend only
    [measures.temperature]: 'TEMPERATURE',
    [measures.volume]: 'VOLUME'
};

const conversionScale = {
    Factor: 'FACTOR',
    Base: 'BASE'
};

const conversionDefinition = {
    [UnitSystemsEnum.Metric]: {
        [measures.length]: {
            [conversionScale.Factor]: unitsList.length.Kilometer,
            [conversionScale.Base]: unitsList.length.Meter
        },
        [measures.speed]: {
            [conversionScale.Factor]: unitsList.speed.KilometrePerHour,
            [conversionScale.Base]: unitsList.speed.MetrePerSecond
        },
        [measures.temperature]: {
            [conversionScale.Factor]: unitsList.temperature.DegreeCelsius
        },
        [measures.mass]: {
            [conversionScale.Factor]: unitsList.mass.Kilogram,
            [conversionScale.Base]: unitsList.length.Gram
        },
        [measures.time]: {
            [conversionScale.Factor]: unitsList.time.Hour,
            [conversionScale.Base]: unitsList.time.Minute
        },
        [measures.volume]: {
            [conversionScale.Factor]: unitsList.volume.CubicMeter,
            [conversionScale.Base]: unitsList.volume.CubicMeter
        }
    },
    [UnitSystemsEnum.Imperial]: {
        [measures.length]: {
            [conversionScale.Factor]: unitsList.length.Mile,
            [conversionScale.Base]: unitsList.length.Yard
        },
        [measures.speed]: {
            [conversionScale.Factor]: unitsList.speed.MilePerHour,
            [conversionScale.Base]: unitsList.speed.FootPerSecond
        },
        [measures.temperature]: {
            [conversionScale.Factor]: unitsList.temperature.DegreeFahrenheit
        },
        [measures.mass]: {
            [conversionScale.Factor]: unitsList.mass.Pound,
            [conversionScale.Base]: unitsList.length.Ounce
        },
        [measures.time]: {
            [conversionScale.Factor]: unitsList.time.Hour,
            [conversionScale.Base]: unitsList.time.Minute
        },
        [measures.volume]: {
            [conversionScale.Factor]: unitsList.volume.Gallon,
            [conversionScale.Base]: unitsList.volume.Gallon
        }
    }
};

const Units = {
    bySystem: unitsBySystemList,
    list: unitsList,
    measures,
    conversionScale,
    conversionDefinition
};

const FilterDisplayUnits = Object.freeze({
    SEC: 'sec',
    MIN: 'min',
    KM: Units.list.length.Kilometer.abbr
});

export const DisplayUnits = Object.freeze({
    km: 'km',
    kms: 'kms',
    hr: 'hr',
    hrs: 'hrs'
});

export const EMISSION_UNIT = 'kg CO2e';

export {
    Units,
    UnitSystemsEnum,
    UnitDimensionsEnum,
    UnitSystemToConvertSystemMap,
    FilterDisplayUnits
};

export default Units;
